<template>
	<v-btn-toggle mandatory>
		<v-menu
			bottom 
			offset-y 
			:close-on-content-click = "false"
		>
			<template v-slot:activator = "{ on : menu }">
				<v-tooltip top>
							
					<template v-slot:activator = "{ on : tooltip}">
						<v-btn
				    		x-small
				    		v-on 	= "{...tooltip, ...menu}"		
				    		v-show 	= "true"
				    		color 	= "primary"
				    		class 	= "ml-1"

			    		>	
			    			<!-- {{ $ml.get('record') }} -->
			    			<v-icon
			    				x-small

			    			>
			    				mdi-playlist-play
			    			</v-icon>		
						</v-btn>
					</template>
						
					<span>
						{{ $ml.get('microphone_selection')   }} : {{ records.selected }}
					</span>
				</v-tooltip>
			</template>
			<v-list 
				dense
			>
				<v-list-item-group 
	              	dense				            				             
	            >
	            	<template v-for = "(item_list, index_list) of list">

			            <v-list-item               
		                	dense
		                	:Key 	   = "ref_to_component + 'record' + index_list"
		                	@click     = "actions('sel_device_input', item_list, index_list)"
			                
		                
		              	>             
			              	<template v-slot:default="{ active }">
		                  		
			                  	<v-list-item-content 
			                  		class = "pa-0 ma-0"
			                  	>
			                    	<v-list-item-title> 
			                    		{{ item_list.text }} 
			                   		</v-list-item-title>
			                  	</v-list-item-content>
			                  	
		                	</template>              
		            	</v-list-item>
		            </template>
		        </v-list-item-group>
		    </v-list>
		</v-menu>
		<v-tooltip top>
			<template v-slot:activator = "{ on }">
				<v-btn
					x-small
					@click = "actions(records.state)"
					v-on 	= "on"	
				>						
					<v-icon
						x-small						
						:color = "records.color"
					>
						mdi-microphone
					</v-icon>	
					<!-- {{  btn.text }} -->
				</v-btn>
			</template>
			<span>
				{{ $ml.get(records.text) }}
			</span>
		</v-tooltip>

		<p 
			:id 	= "ref_to_component + 'duracion'"
			class 	= "pa-0 ma-0"
		></p>
	</v-btn-toggle>
</template>	
<script>

	export default {
		name  	: "record",
		props 	: [
			"info_to_component",
			"type",			
			"ref_to_component",
		],
		data 	: (vm)=>({
			list : [],
			info : {},
			btn  : {
				text : vm.$ml.get("start"),
			},
			records : { 
				state 	 : "start_record",
				color 	 : "white",
				selected : "",
				text 	 : "start_recording",
			},

		}), // data
		created(){
			this.$nextTick(()=>{
				let temp  = this.$Record.get_list("listaDeDispositivos");
				if (temp && temp.options) {
					this.list = temp.options;
					if (this.list && this.list.length > 0) {
						this.actions("sel_device_input", this.list[0]);
					}
				}
			})
		}, // created

		methods : {
			actions(act, item, opt){
				if (act == "sel_device_input") {
					this.$Record.set_audioinput(item.value)
					this.records.selected = item.value;
				}else
				if (act == "start_record") {					
					if (this.info_to_component && this.info_to_component.info) {
						this.$Record.update_list("info", this.info_to_component.info);
					}
					this.$Record.comenzarAGrabar();
					this.records.state 	= "stop_record";
					this.records.color 	= "error";
					this.records.text 	= "stop_recording";

				}else
				if (act == "stop_record") {
					this.$Record.detenerGrabacion();
					this.records.state 	= "start_record";					
					this.records.color 	= "white";
					this.records.text 	= "start_recording";
					


				}
			}, // actions

		}, // methods

		mounted(){
			this.$Record.set_html({
				duration : this.ref_to_component + 'duracion'
			})
		}
 	};
</script>